import * as R from 'ramda';
import { FC } from 'react';
import {
  DeepMap,
  FieldError,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form';

import LotteryUploadDropzone from '@/components/lottery-form/upload-dropzone';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';
import { LotteryFormData } from '@/lib/lottery2';

import { Field } from '..';

interface FileProps {
  register: UseFormRegister<LotteryFormData>;
  watch: UseFormWatch<LotteryFormData>;
  field: Field;
  errors: DeepMap<LotteryFormData, FieldError>;
  onUploaded: (filename: string | null) => void;
}

const LotteryFile: FC<FileProps> = ({
  register,
  watch,
  field,
  errors,
  onUploaded,
}) => {
  const variables = useVariables();

  return (
    <div className="flex flex-col items-start">
      <input
        {...register(field.name, {
          required: field.required,
          ...(field.pattern ? { pattern: field.pattern } : {}),
        })}
        type="hidden"
        id={field.name}
        name={field.name}
      />

      <span className="text-overline mb-2">{field.label}</span>

      <LotteryUploadDropzone onUploaded={onUploaded} />

      {errors?.[field.name] && R.isEmpty(watch(field.name)) && (
        <span className="text-red-medium text-small mt-1">
          {getVariablePlainText(variables['upload-file-required'])}
        </span>
      )}
    </div>
  );
};

export default LotteryFile;
